import { Component, EventEmitter } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators,  } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ChangePasswordModel } from "@model/change-password.model";

@Component({
    templateUrl: "change-password-modal.component.html",
    standalone: false
})
export class ChangePasswordModalComponent {
    title: string = "Change Password";
    submitted: boolean = false;
    submitEvent: EventEmitter<any> = new EventEmitter();
    form: UntypedFormGroup;
    modalRef: BsModalRef;
    changePasswordModel : ChangePasswordModel ={};

    constructor(
        private bsModalRef: BsModalRef,
        private formBuilder: UntypedFormBuilder
        ) {
        this.modalRef = bsModalRef;
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            oldPassword: ['',[Validators.required,Validators.minLength(8)]],         
            newPassword: ['',[Validators.required,Validators.minLength(8)]],           
        });
      }
    
    onSubmit() {
        this.submitted = true;

        if (this.form.invalid ) {
            return;
        }

        
        this.modalRef.hide();
        this.changePasswordModel.oldPassword = this.form.get("oldPassword").value;
        this.changePasswordModel.newPassword = this.form.get("newPassword").value
        this.submitEvent.emit( this.changePasswordModel);
    }

    get f(): { [key: string]: AbstractControl; } {
        return this.form.controls;
      }
}